import {
  CartInteractionEventTrackingSchemas,
  CartInteractionEventTypes,
} from './cart';
import {
  CheckoutInteractionEventTrackingSchemas,
  CheckoutInteractionEventTypes,
} from './checkout';
import {
  LoginInteractionEventTrackingSchemas,
  LoginInteractionEventTypes,
} from './login';
import {
  OtherInteractionEventTrackingSchemas,
  OtherInteractionEventTypes,
} from './others';
import {
  PrescriptionsInteractionEventTrackingSchemas,
  PrescriptionsInteractionEventTypes,
} from './prescriptions';
import {
  SearchInteractionEventTrackingSchemas,
  SearchInteractionEventTypes,
} from './search';

export const InteractionEventTypes = {
  ...CheckoutInteractionEventTypes,
  ...CartInteractionEventTypes,
  ...LoginInteractionEventTypes,
  ...OtherInteractionEventTypes,
  ...SearchInteractionEventTypes,
  ...PrescriptionsInteractionEventTypes,
};

export const InteractionEventTrackingSchemas = {
  ...CheckoutInteractionEventTrackingSchemas,
  ...CartInteractionEventTrackingSchemas,
  ...LoginInteractionEventTrackingSchemas,
  ...OtherInteractionEventTrackingSchemas,
  ...SearchInteractionEventTrackingSchemas,
  ...PrescriptionsInteractionEventTrackingSchemas,
};
